import React from 'react';
import styled from 'styled-components';

const StyleSpan = styled.span`
  position: relative;
  display: inline-block;

  .copylink-share {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default ({ className, isShare }) => (
  <StyleSpan className={className}>
    <svg x="0px" y="0px" viewBox="0 0 51.3 52">
    <g>
      <path d="M45.7,5.9c-1.9-1.9-4.5-3-7.3-3c-2.8,0-5.3,1.1-7.3,3L20.5,16.6c-0.7,0.7-1.2,1.4-1.7,2.2
        c-0.7,1.2-1.1,2.6-1.3,4.1c0,0.2,0,0.4,0,0.6c0,0.7,0,1.3,0.1,2c0,0.3,0.1,0.7,0.2,1c0.4,1.5,1.2,3,2.2,4.2
        c0.2,0.2,0.3,0.3,0.5,0.5c0.2,0.2,0.3,0.3,0.5,0.5l0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.3l0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2
        c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.3,0.1
        c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1l2.1-2.1c0.1-0.1,0.3-0.3,0.4-0.5
        l0.1-0.1c0.1-0.2,0.2-0.3,0.3-0.5c-1.7-0.1-3.2-0.8-4.4-2c-1.6-1.6-2.3-3.9-1.9-6.2l0-0.1c0.2-1.2,0.8-2.2,1.5-3.1
        c0.1-0.1,0.2-0.3,0.3-0.4L33.5,8.5c1.3-1.3,3-2,4.8-2c1.8,0,3.5,0.7,4.8,2c1.3,1.3,2,3,2,4.8c0,1.8-0.7,3.5-2,4.8l-7.5,7.5l0,0
        c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.3,0.1,0.5l0,0.3c0,0.2,0,0.3,0,0.5l0,0.2c0,0.2,0,0.5,0,0.7c0,0.3,0,0.5,0,0.8c0,0.1,0,0.1,0,0.2
        l0,0.2c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.2l0,0.2c0,0.1,0,0.2,0,0.3l10-10c1.9-1.9,3-4.5,3-7.3C48.7,10.4,47.7,7.9,45.7,5.9z"/>
      <g>
        <path d="M5.6,46.1c1.9,1.9,4.5,3,7.3,3s5.3-1.1,7.3-3l10.7-10.7c0.7-0.7,1.2-1.4,1.7-2.2c0.5-1,0.9-2,1.1-3.1
          c0.1-0.7,0.2-1.3,0.2-2c0-0.9-0.1-1.7-0.3-2.6l0,0l0.2-0.1l-0.2,0c-0.3-1.3-0.9-2.5-1.7-3.6c-0.2-0.2-0.3-0.4-0.5-0.6
          c-0.2-0.2-0.3-0.3-0.5-0.5c-0.2-0.2-0.3-0.3-0.5-0.5l-0.2-0.1c-0.1-0.1-0.2-0.2-0.3-0.3l-0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
          c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2l-0.1,0
          c-0.3-0.2-0.7-0.3-1.1-0.3c-1,0-1.8,0.8-1.8,1.8c0,0.8,0.5,1.5,1.3,1.8c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.2,0.1
          c0.2,0.1,0.3,0.2,0.4,0.3l0.2,0.1c0.2,0.2,0.4,0.4,0.6,0.5c1.3,1.3,2,3,2,4.8c0,0.5,0,0.9-0.1,1.3l0,0.2c-0.3,1.1-0.7,2.1-1.5,2.9
          c-0.1,0.1-0.2,0.3-0.4,0.4L17.8,43.5c-1.3,1.3-3,2-4.8,2c-1.8,0-3.6-0.7-4.9-2C8,43.3,7.8,43.2,7.7,43l0-0.1
          c-0.1-0.2-0.3-0.3-0.4-0.5c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.2-0.2-0.3-0.2-0.5c-0.1-0.2-0.2-0.5-0.3-0.7l0-0.1
          c-0.1-0.2-0.1-0.5-0.2-0.7l0-0.1c0-0.2-0.1-0.4-0.1-0.7l0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2l0-0.1c0.1-1.5,0.6-2.8,1.5-4
          l0-0.1C7.8,34.2,8,34,8.1,33.8l7.5-7.5c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.4-0.1-0.7-0.1-1.1l0-0.2c0-0.4,0-0.7,0-1l0-0.2
          c0-0.3,0-0.6,0.1-0.9l0-0.2c0-0.2,0.1-0.5,0.1-0.7l-10,10c-1.9,1.9-3,4.5-3,7.3C2.6,41.5,3.6,44.1,5.6,46.1z"/>
        <polygon points="6.4,39.2 6.4,39.2 6.4,39.2 		"/>
        <polygon points="6.7,40.6 6.7,40.6 6.7,40.6 		"/>
      </g>
    </g>
    </svg>
    {!!isShare && <div className="copylink-share"></div>}
  </StyleSpan>
)